import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Btn from '@material-ui/core/Button'

const Button = ({
  btnStyle,
  children,
  className,
  disabled,
  icon,
  onclick,
  onlyText,
  small,
  title,
  version,
  size,
  testId,
  ...rest
}) => (
  <Btn
    className={classNames(
      'jisr-btn',
      onlyText && 'jisr-btn--only-text',
      children && 'jisr-btn--regular-btn',
      small && 'jisr-btn--size-small',
      // styles
      btnStyle && `jisr-btn--style-${btnStyle}`,
      size && `jisr-btn--size-${size}`,
      version && `jisr-btn-version-${version}`,
      className,
    )}
    variant="contained"
    color="primary"
    disabled={disabled}
    data-testid={testId}
    onClick={onclick}
    {...rest}
  >
    {children || title}
  </Btn>
)

Button.propTypes = {
  onclick: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
  rest: PropTypes.arrayOf(Object),
  btnStyle: PropTypes.string,
  testId: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  onlyText: PropTypes.bool,
  small: PropTypes.bool,
  children: PropTypes.node,
  version: PropTypes.string,
  size: PropTypes.string,
}
export default Button
